import {dateTime} from "services/date";
import deserializeFile from "services/ngage/deserializers/file";
import {PhysicalObject} from "types/PhysicalObject";

/**
 * Transform the given physical object by deserializing object properties
 *
 * @internal
 * @param physicalObject
 */
export default function deserializePhysicalObject(physicalObject: PhysicalObject | any): PhysicalObject {
    physicalObject.created_at = dateTime(physicalObject.created_at)
    physicalObject.updated_at = dateTime(physicalObject.updated_at)

    physicalObject.examples = physicalObject.examples.map(deserializeFile)

    return physicalObject;
}